export const MULTIPLE_ASSIGNEE_OPTIONS = [
  {
    value: false,
    label: 'Task is shared between assignees',
  },
  {
    value: true,
    label: 'Create copies of this task for all assignees',
  },
];

export const ALERT_MESSAGES = {
  413: 'Your attachment is too big to upload to Sling.',
  0: 'Something went wrong while uploading the attachment. Please try again later.',
};
